
// src/connects/notifications-tab.js

import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import actions from '../actions'
import lifecycle from '../helpers/lifecycle'
import combineHOC from '../helpers/combine-hoc'

export const mapStateToProps = (state, ownProps)=> {
  const group = state.notifications.groups[ownProps.group_id] || {}
  return {
    isFetching: group.isFetching,
    isFetchFailed: group.isFetchFailed,
    hasMore: group.hasMore,
    notifications: group.items,
    currentDivisionId: state.divisions.currentId,
  }
}

export const mapDispatchToProps = (dispatch, ownProps)=> {
  return {
    fetchNotifications: (props)=> {
      var offset = props.notifications && props.notifications.length || 0
      if (ownProps.group_id == 'home') {
        const { currentDivisionId } = props
        dispatch(actions.fetchHomeNotifications(offset, currentDivisionId))
      }
      else
        dispatch(actions.fetchNotifications(ownProps.group_id, offset))
    },
    willMount: (props)=> {
      if (ownProps.group_id == 'home') {
        const { currentDivisionId } = props
        dispatch(actions.fetchHomeNotifications(0, currentDivisionId))
        dispatch(actions.flushUnreadHomeNotifications(currentDivisionId))
      }
      else {
        dispatch(actions.fetchNotifications(ownProps.group_id, 0))
        dispatch(actions.flushUnreadNotifications(ownProps.group_id))
      }
    },
  }
}

export default combineHOC(
  connect(mapStateToProps, mapDispatchToProps),
  lifecycle,
  translate(),
)



// WEBPACK FOOTER //
// ./src/connects/notifications-tab.js